import { lazy, Suspense } from "react";
import { PreviewModal } from "components/ChatPreviewModal/ChatPreviewModal";
import { Button } from "components/DesignSystem/Button/Button";
import { CenteredLoader } from "components/DesignSystem/Loader/loader";
import { DownloadIcon } from "components/icons/Download";
import PreviewImageName from "static/images/PreviewImageName.svg";

const SpreadsheetPreview = lazy(
  () => import("components/SpreadsheetPreview/SpreadsheetPreview")
);

type ChatSpreadsheetPreviewModalProps = {
  name: string;
  url: string | null;
  onClose: () => void;
};

export const ChatSpreadsheetPreviewModal = ({
  name,
  url,
  onClose,
}: ChatSpreadsheetPreviewModalProps) => {
  if (!url) return null;

  const handleDownload = () => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = name;
    anchor.click();
  };

  return (
    <PreviewModal
      open
      onClose={onClose}
      title={
        <>
          <img src={PreviewImageName} alt={name} />
          {name}
          <Button customType="ghost" size="small" onClick={handleDownload}>
            <div className="t-text-neutral-0 group-hover:t-text-neutral-100">
              <DownloadIcon color="currentColor" />
            </div>
          </Button>
        </>
      }
    >
      <Suspense fallback={<CenteredLoader />}>
        <SpreadsheetPreview preview_url={url} name={name} fullWidth />
      </Suspense>
    </PreviewModal>
  );
};
